import { FC } from "react";
import { FormHelperText, Stack, Typography } from "@mui/material";
import { AutomationResourceFilters } from "./AutomationResourceFilters";
import { AutomationResourceFiltersExpandWrapper } from "./AutomationResourceFiltersExpandWrapper";
import { AutomationResourceItemProps } from "../AutomationResource";
import { AutomationsFoundResources } from "../AutomationsFoundResources";
import { useAppSelector } from "../../../../../../../../../store/hooks";
import { automationAccountIdsSelector } from "../../../../../../../../../store/automations/selectros/common/fields/automationAccountIdsSelector";
import { automationRegionsSelector } from "../../../../../../../../../store/automations/selectros/common/fields/automationRegionsSelector";

import { workflowActionSelector } from "../../../../../../../../../store/automations/selectros/workflow/workflowActionSelector";

import { automationIdSelector } from "../../../../../../../../../store/automations/selectros/common/automationIdSelector";
import { workflowGracePeriodSelector } from "../../../../../../../../../store/automations/selectros/workflow/workflowGracePeriodSelector";
import { ResourceFiltersWithAction } from "../../../../../../../../../services/cloudchipr.api";
import { FiltersDisabledView } from "../../../../../../../common/filters/filters-disabled-view/FiltersDisabledView";

interface AutomationResourceFiltersSectionProps
  extends AutomationResourceItemProps {
  filterChangeHandler(filter: ResourceFiltersWithAction[]): void;
}

export const AutomationResourceFiltersSection: FC<
  AutomationResourceFiltersSectionProps
> = ({ index, resourceFilters, error, filterChangeHandler }) => {
  const accountIds = useAppSelector(automationAccountIdsSelector);
  const regions = useAppSelector(automationRegionsSelector);
  const workflowAction = useAppSelector(workflowActionSelector);
  const automationId = useAppSelector(automationIdSelector) ?? "";
  const gracePeriodEnabled = !!useAppSelector(workflowGracePeriodSelector)
    ?.period;
  const resourceType = resourceFilters.filter.type;
  const filtersLength = resourceFilters.filter.filter_items.length;

  return (
    <AutomationResourceFiltersExpandWrapper
      title={
        <Stack
          flex={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack alignItems="start">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="body2"
                bgcolor="grey.100"
                py={0.25}
                px={0.5}
                borderRadius={1}
              >
                <Typography
                  variant="inherit"
                  component="span"
                  fontWeight="medium"
                >
                  {resourceFilters.filter.filter_items.length}
                </Typography>{" "}
                filter{filtersLength > 1 ? "s" : ""} applied
              </Typography>

              <AutomationResourceFilters
                index={index}
                onChange={filterChangeHandler}
                resourceFilters={resourceFilters}
              />
            </Stack>

            {error && <FormHelperText error>{error}</FormHelperText>}
          </Stack>

          <AutomationsFoundResources
            regions={regions}
            scheduleId={automationId}
            accountIds={accountIds}
            resourceType={resourceType}
            scheduleAction={workflowAction}
            resourceFilters={resourceFilters}
            gracePeriodEnabled={gracePeriodEnabled}
          />
        </Stack>
      }
    >
      <FiltersDisabledView filter={resourceFilters.filter} />
    </AutomationResourceFiltersExpandWrapper>
  );
};
